import { sanitizeRichText } from "../../../../../utils/sanitizeRichText";

type SafeJoditConfigParams = {
    readonly: boolean;
    height: number;
    placeholder: string;
    buttons: string[];
};

const DENY_TAGS =
    "script,iframe,object,embed,link,meta,form,input,button,textarea,select,style,svg,math,video,audio,source,base,applet,frame,frameset,noscript";

export const getSafeJoditConfig = ({
    readonly,
    height,
    placeholder,
    buttons,
}: SafeJoditConfigParams) => ({
    readonly,
    height,
    toolbarAdaptive: false,
    toolbarSticky: true,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_clear_html",
    uploader: {
        insertImageAsBase64URI: true,
    },
    language: "en_gb",
    spellcheck: true,
    placeholder,
    iframe: false,
    allowScripts: false,
    cleanHTML: {
        fillEmptyParagraph: false,
        safeJavaScriptLink: true,
        removeOnError: true,
        denyTags: DENY_TAGS,
    },
    buttons,
    events: {
        afterPaste(this: { value: string }) {
            this.value = sanitizeRichText(this.value);
        },
    },
});
